import {useAssessmentApi} from '../api/assessment';
import {useEffect, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {AnimationLoadingScreen} from '../components/loading/loadingScreen';

const toolToRoutes = {
  Nuralogix: ['/pre-face-scan'],
  DermaDetect: ['/skin-condition'],
  CoughDetection: ['/cough-symptoms', '/reader-symptoms', '/recording-confirmation-1', '/recording-confirmation-2'],
  Hehealth: ['/men-sexual-health'],
};
const enablePrivateAccess = true;

/**
 * Component to control private access based on assessment data tool.
 *
 * @param {Object} props - React props containing the element to be rendered.
 * @param {JSX.Element} props.element - The JSX element to be rendered if access is granted.
 * @returns {JSX.Element} The JSX element for controlling private access.
 */
export const PrivateAccess = ({element}) => {
  const [renderElement, setRenderElement] = useState(null); // Manage the element to be rendered
  const assessmentApi = useAssessmentApi();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.pathname || '/';

  useEffect(() => {
    const fetchData = async () => {
      if (!enablePrivateAccess) {
        setRenderElement(element);
        return;
      }
      const userAssesmentReq = await assessmentApi.getLatestAssessment();
      if (userAssesmentReq.status !== 200) {
        navigate('/demographics');
        return;
      }
      const userAssessmentID = userAssesmentReq.data.id;
      let nextToolReq = await assessmentApi.getNextNeededTool(userAssessmentID);
      if (nextToolReq.status !== 200) {
        navigate('/demographics');
        return;
      }

      if (toolToRoutes[nextToolReq.data]?.includes(from)) {
        setRenderElement(element);
        return;
      }
      navigate(toolToRoutes[nextToolReq.data]?.[0] || '/results');
    };
    fetchData();
  }, [element, from, navigate, assessmentApi]);

  // Render the element conditionally
  return renderElement;
};
